import { makeStyles } from "@mui/styles";
import type { FC } from "react";

const useStyles = makeStyles(() => ({
    root: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        alignItems: "center",
        backgroundColor: "#F5FAFE",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "100%",
    },
}));

const LoadingScreen: FC = () => {
    const classes = useStyles();

    return <div className={classes.root}></div>;
};

export default LoadingScreen;
